import {useCallback, useEffect, useState} from 'react';

export const useMute = video => {
  const [forceMuted, setForceMuted] = useState(false);
  const [muted, setMuted] = useState(false);

  useEffect(() => {
    if (video?.muted) {
      setForceMuted(true);
    } else {
      setForceMuted(false);
    }
  }, [video]);

  const toggleMute = useCallback(() => {
    setMuted(prev => !prev);
  }, []);

  return {muted, forceMuted, setMuted, toggleMute};
};
